import React, { Component } from 'react';
import classSet from 'react-classset';
import Cookies from 'js-cookie';
import Modal from '../Modal/Modal';
import Intro from '../Intro/Intro';
import { getComponentContent } from '../../helpers.js';
import AppBackground from '../AppBackground/AppBackground';

class LandingPage extends Component {

  constructor() {
    super();
    this.state = {
      mounted: false,
      showIntro: false
    }
    this.handleLandingClick = this.handleLandingClick.bind(this);
    this.setShowIntro = this.setShowIntro.bind(this);
    this.content = getComponentContent('LandingPage');
  }

  componentDidMount() {
    setTimeout( () => {
      this.setState({mounted: true});
    }, 25);
  }

  handleLandingClick() {
    if (Cookies.get('dermalogica-sleep-cocoon-intro') !== 'true') {
      this.setState({showIntro: true});
    } else {
      this.props.history.push('/player');
    }
  }

  setShowIntro(val) {
    this.setState({showIntro: val});
    if (!val) {
      this.props.history.push('/player');
    }
  }

  render() {

    const landingPageClasses = classSet({
      'ssc__page': true,
      'ssc__page--landing': true,
    });   

    const pageWrapperClasses = classSet({
      'ssc__page-wrapper': true,
      'ssc__page-wrapper--mounted': this.state.mounted,
      'ssc__page-wrapper--hide-landing': this.state.showIntro
    });

    const cta = this.props.touch ? this.content.tapCta : this.content.clickCta;

    return (

      <div className={pageWrapperClasses} style={{height: this.props.appHeight}}>

        <AppBackground
          showVideo={true}
          playsInline={this.props.playsInline}
          appHeight={this.props.appHeight}
          disableMask={true}
          onVideoEnded={this.handleLandingClick}
        />

        {this.state.showIntro &&
          <Modal
            slideIn={true}
            onClose={this.setShowIntro}
            showBackground={true}
            appHeight={this.props.appHeight}
          >
            <Intro 
              orientation={this.props.orientation}
              touch={this.props.touch}
              history={this.props.history}
            />
          </Modal>
        }

        <div className={landingPageClasses} onClick={this.handleLandingClick}>
          <div className="ssc__page__inner">
            <h1>sound sleep cocoon</h1>
          </div>
          <h3 className="ssc__text-uppercase">{cta}</h3>
        </div>

      </div>

    );

  }
  
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.js